import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client.ts";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request.ts";

export default function useUpdateReturnRequestDeactivateAutoTreatLogistician() {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateReturnRequest = useInvalidateReturnRequest();

  return $api.useMutation(
    "patch",
    "/shops/{shopId}/return-requests/{returnRequestId}/deactivate-auto-treat-logistician",
    {
      onSuccess(returnRequest) {
        successNotification();
        setTimeout(
          () =>
            invalidateReturnRequest({
              returnRequestId: returnRequest.id,
              shopId: returnRequest.shopId,
            }),
          100,
        );
      },
      onError() {
        errorNotification();
      },
    },
  );
}
